import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';
import ShopServiceModel from '@/models/ShopServiceModel';

@model.cacheDuration()
@model.urnResource('order_item_unit_status')
@doc.path('/order_item_unit_statuses/{?id}')
export default class OrderItemUnitStatusModel extends ShopServiceModel {
	@doc.string declare label: string;
	@doc.string declare reference: Shop_OrderItemUnitStatusReference;
	private declare _tsFilters: {
		'reference': Shop_OrderItemUnitStatusReference;
	};
	private declare _tsSorts: {
		'id': string;
	};

	public get color() {
		switch (this.reference) {
			case 'to_validate':
				return 'blue';
			case 'created':
				return 'green';
		}
	}
}
